var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowParagraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5c9dff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,7H1A.945.945,0,0,1,0,6V2A.945.945,0,0,1,1,1H5A.945.945,0,0,1,6,2V6A.945.945,0,0,1,5,7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8,
    height: 2,
    transform: "translate(8 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 8,
    height: 2,
    transform: "translate(8 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 2,
    transform: "translate(0 9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 16,
    height: 2,
    transform: "translate(0 13)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowParagraph);
export default __webpack_public_path__ + "static/media/window_paragraph.2cb3418b7246c8103cef584620e8b5ca.svg";
export { ForwardRef as ReactComponent };